/**
 * Single answer to "may this category run in the web app right now?".
 * Extension contexts keep their existing behaviour (spec section 9 is a separate decision).
 */
import { isExtensionContext } from "@common/services/detect-context";
import { hasAnalyticsConsent, hasMarketingConsent } from "./store";

export function consentAllows(category: "analytics" | "marketing"): boolean {
  if (isExtensionContext()) return true;
  return category === "analytics" ? hasAnalyticsConsent() : hasMarketingConsent();
}
